var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.032 23.008L22.016 14.176H23.008V23.04C23.008 23.3067 22.912 23.5307 22.72 23.712C22.528 23.904 22.2987 24 22.032 24H8V9.968C8 9.70133 8.09067 9.472 8.272 9.28C8.464 9.088 8.69333 8.992 8.96 8.992H17.824V9.984H8.96L8.992 23.008H22.032ZM14.32 16.976L15.312 15.968L16.032 16.688L15.024 17.68L14.32 16.976ZM23.296 8L24 8.704L16.752 15.952L16.048 15.248L20.496 10.8L20.992 10.288L22 9.296L23.296 8Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3ea209c56449a9c1e41e1cf60c1eed69.svg";
export { ForwardRef as ReactComponent };